/**
 * Created by yazan on 22/10/15.
 */
window.BrandQuestionsForm = function(scope, brand, idObj, positionName) {
  var self = this;
  var formName = "brand-questions-form";
  self.name = formName;
  self.status = {completed: true};
    self.brand = brand;
  var _protected = BaseForm.call(self, formName, scope);

    var availabilityData = {};

  self.load = function() {
    SettingsAPI.loadAnswersForBrandQuestion(brand.id)
      .then(function(data) {
          var answers = {};
          data.data.forEach(function (answer){

            if (answer.answer) {
                if (answer.answer.trim) {
                    if (answer.answer.trim()) {
                        answers[answer.code] = answer.answer;
                    }
                }
                else {
                    answers[answer.code] = answer.answer;
                }
            }
          });

          if (!answers[1]) {
            answers[1] = {answer : (positionName && positionName.alias_position) ?
                        positionName.alias_position : (positionName.Position && positionName.Position.name || positionName.position && positionName.position.name) };
          }

          if (answers[1] && answers[1].answer) {
            answers[1].answer = $filter("translate")(answers[1].answer);
          }

          if (answers[2]) {
            answers[2].answer = new Date(answers[2].answer);
          }


            self.data.answers = answers;
            AvailabilityAPI.load()
                .then(function(data) {
                    availabilityData = data;
                    if (!answers[7]) {
                        answers[7] = {};

                        if (availabilityData.full_time) {
                            answers[7].answer = 'full-time';
                        }
                        else if (availabilityData.part_time) {
                            answers[7].answer = 'part-time';
                        }
                        else if (availabilityData.anytime) {
                            answers[7].answer = 'temporary';
                        }
                    }
                    setTimeout(function () {
                        self.completeStatus();
                    }, 1000);
                });
        });
  };

  self.validator.afterValidation(function () {
      self.completeStatus();
  });

    self.completeStatus = function () {
        self.status.completed = self.validator.validateWithoutError();

        if (scope) {
            try {
                scope.$digest();
            }
            catch (e) { /* Do Nothing */ }
        }
        else {
            console.warn("Scope is not here: form name: ", name);
        }
    };

  self.save = function() {
    var defer = $q.defer();


    if (self.data.answers[12]) {
      if (self.data.answers[4].answer == 'no') {
        delete self.data.answers[12];
      }
    }

    SettingsAPI.addAnswersForBrandQuestion(self.data.answers, idObj)
        .then(
        function(res) {
            defer.resolve(res);
        },
        function(err) {
          defer.reject(err);
        });

    return defer.promise;
  };

  self.addNewbrandQuestions = function() {
  };


    self.load();
}
